import React, { useRef } from 'react';
import { Link } from 'react-router-dom';
import { Plus, ChevronLeft, ChevronRight } from 'lucide-react';
import { useCart } from '../contexts/CartContext';
import namkeFallback from '../assets/namke-fallback.png';

const SimilarDishesCarousel = ({ title = 'Plats similaires', dishes = [] }) => {
  const scrollerRef = useRef(null);
  const { addToCart } = useCart();

  const scrollByPage = (direction) => {
    const el = scrollerRef.current;
    if (!el) return;
    el.scrollBy({ left: direction * el.clientWidth * 0.9, behavior: 'smooth' });
  };

  const handleQuickAdd = (e, dish) => {
    e.preventDefault();
    e.stopPropagation();
    addToCart({
      id: dish.id,
      name: dish.name,
      price: dish.price,
      image: dish.dish_image_url || dish.image,
      restaurantId: dish.restaurant_id || dish.restaurantId,
      restaurantName: dish.restaurant?.name || dish.restaurantName,
      quantity: 1,
      supplements: [],
    });
  };

  if (!dishes.length) return null;

  return (
    <div className="mt-8 sm:mt-12">
      <div className="flex items-center justify-between mb-4 sm:mb-6">
        <h2 className="text-xl sm:text-2xl font-bold text-gray-900">{title}</h2>
        <div className="hidden sm:flex items-center gap-2">
          <button
            type="button"
            onClick={() => scrollByPage(-1)}
            aria-label="Précédent"
            className="w-9 h-9 rounded-full bg-gray-100 hover:bg-gray-200 text-gray-700 flex items-center justify-center transition-colors"
          >
            <ChevronLeft size={18} />
          </button>
          <button
            type="button"
            onClick={() => scrollByPage(1)}
            aria-label="Suivant"
            className="w-9 h-9 rounded-full bg-gray-100 hover:bg-gray-200 text-gray-700 flex items-center justify-center transition-colors"
          >
            <ChevronRight size={18} />
          </button>
        </div>
      </div>

      <div
        ref={scrollerRef}
        className="flex gap-4 overflow-x-auto pb-2 snap-x snap-proximity scroll-smooth [&::-webkit-scrollbar]:hidden"
        style={{ scrollbarWidth: 'none', msOverflowStyle: 'none' }}
      >
        {dishes.map((dish) => (
          <Link
            key={dish.id}
            to={`/product/${dish.id}`}
            className="group shrink-0 snap-start w-40 sm:w-48"
          >
            <div className="relative w-40 h-40 sm:w-48 sm:h-48 rounded-xl overflow-hidden bg-gray-100">
              <img
                src={dish.dish_image_url || dish.image || namkeFallback}
                alt={dish.name}
                className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-300"
                onError={(e) => { e.target.src = namkeFallback; }}
              />
              <button
                type="button"
                onClick={(e) => handleQuickAdd(e, dish)}
                aria-label="Ajouter au panier"
                className="absolute bottom-2 right-2 w-9 h-9 rounded-full bg-white shadow-md text-gray-900 flex items-center justify-center hover:bg-gray-100 transition-colors"
              >
                <Plus size={18} />
              </button>
            </div>
            <p className="mt-2 text-base font-bold text-gray-900">
              {Number(dish.price || 0).toFixed(2)} €
            </p>
            <p className="text-sm text-gray-500 line-clamp-2">{dish.name}</p>
          </Link>
        ))}
      </div>
    </div>
  );
};

export default SimilarDishesCarousel;
